import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { BrowserService } from '../services/browser.service';
import { API_CONSTANTS } from 'src/app/constants';
import {
  forceLogoutStaleSession,
  isStoredSessionMissingToken,
} from 'src/app/helpers/login-session.helper';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _browserService: BrowserService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (
      this._browserService.checkBrowser() &&
      isStoredSessionMissingToken()
    ) {
      forceLogoutStaleSession(this._authService);
      return false;
    }
    if (this._authService.isAuthenticated()) {
      return true;
    }
    const emailHint = next.queryParamMap.get('e');
    this._router.navigate([API_CONSTANTS.LOGIN], {
      queryParams: {
        returnUrl: state.url,
        ...(emailHint ? { e: emailHint } : {}),
      },
    });
    return false;
  }
}

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state,
) => {
  return inject(PermissionsService).canActivate(route, state);
};
